//用于和APP的原生方法交互（在H5的项目中主要调用isapp的方法判定是否在APP中来判断是否显示导航栏）
let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);


//这是必须要写的，用来创建一些设置
function setupWebViewJavascriptBridge(callback) {
    //Android使用
    if (isAndroid) {
        if (window.WebViewJavascriptBridge) {
            callback(WebViewJavascriptBridge)
        } else {
            document.addEventListener(
                'WebViewJavascriptBridgeReady',
                function () {
                    callback(WebViewJavascriptBridge)
                },
                false
            );
        }
        console.log('tag', '安卓')
        sessionStorage.phoneType = 'android'
    }

    //iOS使用
    if (isiOS) {
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe)
        }, 0);
        console.log('tag', 'ios');
        sessionStorage.phoneType = 'ios'
    }
}


//注册回调函数，第一次连接时调用 初始化函数(android需要初始化,ios不用)
setupWebViewJavascriptBridge(function (bridge) {
    if (isAndroid) {
        //初始化
        bridge.init(function (message, responseCallback) {
            var data = {
                'Javascript Responds': 'Wee!'
            };
            responseCallback(data);
        })
    }
})



export default {
    // js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
    callHandler(name, data, callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(name, data, callback)
        })
    },
    // APP调js方法 （参数分别为:js提供的方法名  回调）
    registerHandler(name, callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(name, function (data, responseCallback) {
                callback(data, responseCallback)
            })
        })
    }
}


/*具体调用方法:
必须识别window.WebViewJavascriptBridge，必须在原生端，否则报undefinded，无法使用该插件
方法需要在app中自定义
vitaJsBridgeToNative      // js掉app中的方法vitaJsBridgeToNative
vitaJsBridgeFromNative    // app掉js中的方法vitaJsBridgeFromNative


main.js
    import Bridge from '@/utils/JSbridge.js'    // app和html通讯
    Vue.prototype.$bridge = Bridge


页面：
mounted(){
    // console.log("window.WebViewJavascriptBridge: ",window.WebViewJavascriptBridge);
    // alert("window.WebViewJavascriptBridge",window.WebViewJavascriptBridge);

    // url上回传递参数dataType表示data数据业务类型
    // js调app：通过data发送数据到app
    this.$bridge.callHandler("vitaJsBridgeToNative", '1232132325442123', (res) => {
        console.log("js调app res: ",res);
        alert("js调app res: ",res);
    });

    // app调js：接受app发送过来的数据res
    this.$bridge.registerHandler("vitaJsBridgeFromNative",  (res) => {
        console.log("app调js res: ",res);
        alert("app调js res: ",res);
    });
},
*/